<template>
  <div class="voiceComposeCustom">
    <div class="header">
      <div class="left">
        <div class="logo">
          <img src="../assets/img/voiceComposeCustom/logo.png" />
        </div>
      </div>
      <div class="right">
        <div class="title">
          <span>名称：</span>
          <span v-show="!isEdit">{{ title }}</span>
          <input
            v-if="isEdit"
            v-model="title"
            placeholder="未命名报道"
            type="text"
          />
          <img
            v-show="!isEdit"
            @click="isEdit = true"
            class="edit-btn"
            src="../assets/img/voiceComposeCustom/edit.png"
          />
        </div>
        <div class="btn-container">
          <el-button
            :loading="isComposing"
            class="btn btn-compose"
            @click="compose"
          >
            {{ isComposing ? "合成中" : "合成" }}
          </el-button>
          <el-button class="btn btn-save" @click="save" :loading="isComposing">保存</el-button>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="sidebar">
        <div class="sidebar-hint">音色选择</div>
        <div class="voice-list">
          <div
            v-for="item in voiceList"
            :key="item.id"
            class="voice-item"
            :class="{ active: selectedVoice === item.speaker_id }"
            @click="selectVoice(item)"
          >
            <div class="voice-item-name">{{ item.name }}</div>
            <div
              class="voice-item-img"
              :class="{ isPlaying: playingVoice === item.speaker_id }"
            >
              <img
                class="voice-item-img-play"
                src="../assets/img/voiceComposeCustom/play.png"
                @click.self="playVoice(item)"
              />
              <img
                class="voice-item-img-live"
                src="../assets/img/voiceComposeCustom/live.gif"
                @click.self="pauseVoice(item)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <ssml-editor
          ref="ssmlEditor"
          :class="!previewUrl ? 'main-editor' : 'main-editor-preview'"
          :max-length="20000"
          :default-voice="selectedVoice"
          :voice-list="voiceList"
        />
        <div v-if="previewUrl" class="preview-audio">
          <div class="left">
            <span>试听：</span>
            <VoiceComposePlayer :audio-src="previewUrl" />
          </div>
          <div class="right">
            <div class="btn-preview btn-download" @click="handleDownload">音频下载</div>
            <Dropdown @command="handleCommand">
              <div class="btn-preview btn-insert">创建</div>
              <Dropdown-menu slot="dropdown" class="voice-compose-btns">
                <Dropdown-item v-show="objid && objtype == 'publish'" command="editPublish">创建发布</Dropdown-item>
                <Dropdown-item v-show="objid && objtype == 'material'" command="editMaterial">上传线索</Dropdown-item>
                <Dropdown-item v-show="!objid && !objtype" command="newPublish">创建发布</Dropdown-item>
                <Dropdown-item v-show="!objid && !objtype" command="newMaterial">上传线索</Dropdown-item>
              </Dropdown-menu>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import SsmlEditor from "@/components/ssml-editor";
import VoiceComposePlayer from "@/components/voiceComposePlayer.vue";
import common from "@common/common";
import { apis } from "@common/config";
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";

Vue.use(SsmlEditor);

export default {
  name: "VoiceComposeCustom",

  components: {
    VoiceComposePlayer,
    Dropdown,
    DropdownMenu,
    DropdownItem,
  },

  data() {
    return {
      id: "",
      objid: "", // 稿件ID
      objtype: "", // 稿件类型
      t: "",
      title: "未命名报道",
      isEdit: false,
      content: "",
      selectedVoice: "", // 当前选中的音色
      voiceList: [], // 音色列表
      playingVoice: "", // 正在播放的音色
      audioContext: null,
      audioBuffer: null,
      isComposing: false,
      previewUrl: "",
      materialId: "",
      task_id: "",
      idstring: ""
    };
  },
  computed: {
    getObjTypeText() {
      let text = "";
      switch (this.objtype) {
        case "report":
          text = "报道";
          break;
        case "material":
          text = "线索";
          break;
        case "publish":
          text = "发布";
          break;
        default:
          break;
      }

      return text;
    }
  },

  methods: {
    // 选择音色
    selectVoice(voice) {
      this.selectedVoice = voice.speaker_id;
    },
    /**
     * 校验 SSML 内容是否有效，确保 tts_text 中 <speak> 标签内的内容不全是标点符号
     * @param {Array} ssmlArray - splitSSMLByVoiceAndSpeed 返回的数组
     * @returns {boolean} - 校验结果，true 表示所有项都有效，false 表示至少有一个无效
     */
    validateSSML(ssmlArray) {
      console.log("ssmlArray", ssmlArray)
      // 正则表达式：匹配仅由标点符号组成的字符串（中英文标点均包括）
      // const punctuationOnlyRegex = /^[\u3000-\u303F\uFF00-\uFFEF\s\p{P}]+$/u;
      const punctuationOnlyRegex = /^[\u3000-\u303F\uFF00-\uFFEF\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~，。！？、；：“”‘’（）《》【】]+$/;

      for (const item of ssmlArray) {
        const ttsText = item.tts_text;

        // 检查 tts_text 是否以 <speak> 开头并以 </speak> 结尾
        const speakTagMatch = ttsText.trim().match(/^<speak>([\s\S]*)<\/speak>$/i);
        if (!speakTagMatch) {
          console.log('标签缺失', `tts_text 缺少 <speak> 或 </speak> 标签: ${ttsText}`);
          return false;
        }

        const content = speakTagMatch[1].trim();
        if (punctuationOnlyRegex.test(content)) {
          console.log('校验失败', `内容仅包含标点符号: ${ttsText}`);
          return false;
        }
      }

      return true; // 所有项都通过校验
    },

    // 合成方法
    compose() {
      if (this.isComposing) {
        return;
      }
      // 获取最终SSML
      const ssml = this.$refs.ssmlEditor.getFinalSSML();
      // 默认发言人ID
      const defaultSpeakerId = this.selectedVoice;
      // 拆分SSML，处理多人配音
      const requests = this.$refs.ssmlEditor.splitSSMLByVoiceAndSpeed(
        ssml,
        defaultSpeakerId
      );
      if (!this.validateSSML(requests)) {
        this.$toast("编辑格式错误，部分内容仅包含标点符号");
        return;
      }
      // 发送请求到后端
      this.sendSSMLToBackend(requests);
    },

    // 发送SSML到后端
    sendSSMLToBackend(requests) {
      this.isComposing = true;
      let ssml = JSON.stringify(requests);
      const html = this.$refs.ssmlEditor.getContent();
      common
        .myFetch(apis.startSpeechTtsMulti, {
          id: this.id ? this.id : "",
          tts_list: ssml,
          title: this.title,
          encoding: "mp3",
          objid: this.objid,
          objtype: this.objtype,
          show_content: html
        })
        .then((data) => {
          if (data) {
            this.$toast("音频合成信息已保存");
            this.resetPreview()
            if (!this.$route.query.d || this.$route.query.d != data.id) {
              this.$router.replace({
                path: "/voiceComposeCustom",
                query: {
                  ...this.$route.query, 
                  d: data.id,
                },
              });
            }
            if (!data.scube_task_ids || data.scube_task_ids == "[]") {
              this.$toast("格式错误");
              this.isComposing = false;
            }

            this.task_id = data.task_id;
          } else {
            this.isComposing = false;
          }
        })
        .catch(() => {
          this.isComposing = false;
        })
    },

    // 保存方法
    save() {
      if (this.isComposing) {
        return;
      }
      // 获取最终SSML
      const ssml = this.$refs.ssmlEditor.getFinalSSML();
      const html = this.$refs.ssmlEditor.getContent();
      // 默认发言人ID
      const defaultSpeakerId = this.selectedVoice;
      // 拆分SSML，处理多人配音
      const requests = this.$refs.ssmlEditor.splitSSMLByVoiceAndSpeed(
        ssml,
        defaultSpeakerId
      );
      if (!this.validateSSML(requests)) {
        this.$toast("编辑格式错误，部分内容仅包含标点符号");
        return;
      }
      const ssmlFinal = JSON.stringify(requests);
      common
        .myFetch(apis.saveSpeechTtsMulti, {
          id: this.id ? this.id : "",
          tts_list: ssmlFinal,
          title: this.title,
          encoding: "mp3",
          vid: this.selectedVoice,
          show_content: html
        })
        .then((data) => {
          if (data) {
            this.$toast("音频合成信息已保存");
            if (!this.$route.query.d || this.$route.query.d != data.id) {
              this.$router.replace({
                path: "/voiceComposeCustom",
                query: {
                  ...this.$route.query, 
                  d: data.id,
                },
              });
            } else {
              this.$router.go(0)
            }
          }
        });
    },
    // 播放音色示例
    async playVoice(voice) {
      try {
        // 如果正在播放同一个音色,则停止播放
        if (this.playingVoice === voice.speaker_id) {
          this.stopVoice();
          return;
        }

        // 停止其他正在播放的音色
        this.stopVoice();

        // 初始化音频上下文
        if (!this.audioContext) {
          this.audioContext = new (window.AudioContext ||
            window.webkitAudioContext)();
        }

        const audioUrl = voice.demo_audio;

        // 加载并播放音频
        const response = await fetch(audioUrl);
        const arrayBuffer = await response.arrayBuffer();
        this.audioBuffer = await this.audioContext.decodeAudioData(arrayBuffer);

        const source = this.audioContext.createBufferSource();
        source.buffer = this.audioBuffer;
        source.connect(this.audioContext.destination);

        // 设置播放结束的处理
        source.onended = () => {
          this.playingVoice = "";
        };

        source.start(0);
        this.playingVoice = voice.speaker_id;
      } catch (error) {
        this.$message.error("播放失败");
      }
    },
    pauseVoice(voice) {
      if (this.playingVoice === voice.speaker_id) {
        this.stopVoice();
        return;
      }
    },

    // 停止播放
    stopVoice() {
      if (this.audioContext) {
        this.audioContext.close();
        this.audioContext = null;
      }
      this.playingVoice = "";
    },
    getVoiceList() {
      this.voiceList = [];

      common.myFetch(apis.getSpeakerList, {}).then((data) => {
        if (data && data.length > 0) {
          this.voiceList = data;

          // 默认选中第一个音色
          if (!this.selectedVoice && this.voiceList.length > 0) {
            this.selectedVoice = this.voiceList[0].speaker_id;
          }

          if (this.id && this.id != "") {
            this.getDetail();
          } else if (this.objid && this.objid != "") {
            this.getSourceDetail();
          }
        }
      });
    },
    getDetail() {
      let info = {
        id: this.$route.query.d,
      };

      common.myFetch(apis.makeupAudioDetail, info).then((r) => {
        if (r) {
          this.title = r.title;

          this.voiceList.forEach((el, index) => {
            if (el.speaker_id == r.vid) {
              this.selectedVoice = el.speaker_id;
            }
          });

          let ssml = "";
          if (r.content) {
            let content = JSON.parse(r.content);
            ssml = this.$refs.ssmlEditor.mergeTTSArrayToEditorHtml(content, this.selectedVoice, this.voiceList);
            this.$refs.ssmlEditor.setContent(ssml, r.show_content);
          }
        }
      });
    },
    getSpeechResult(result) {
      if (result && result.content &&
       result.content.content.task_id == this.task_id) {
        this.isComposing = false;
        if (result.content.url) {
          this.$toast("合成成功");
          this.previewUrl = result.content.url;
          this.materialId = result.content.id;
          this.idstring = result.content.idstring;
        } else {
          this.$toast("合成失败");
        }
      }
    },
    resetPreview() {
      this.previewUrl = "";
      this.materialId = "";
      this.idstring = "";
    },
    // 获取源稿件详情
    getSourceDetail() {
      let info = {
        id: this.objid,
        type: this.t ? this.t : '',
      }

      common.myFetch(apis.publish_editinfo, info).then(async r => {
        if (r && r.detail) {
          this.title = r.detail.title;
          if (r.detail.html_content) {
            this.$refs.ssmlEditor.setContent(r.detail.html_content);
          }
        }
      })
    },
    async newPublish() {
      const typeName = await this.$pageType("publish");
      if (!typeName || !this.materialId) return;
      let info = {
        id: this.materialId,
        push_to: 'publish',
        type: typeName
      };
      common.myFetch(apis.File_filepush, info).then(r => {
        if (r) {
          common.jump(`/createPublish?t=${typeName}&d=${r.id}`, true);
        }
      });
    },
    newMaterial() {
      if (!this.materialId) return;
      let info = {
        id: this.materialId,
        push_to: 'material',
        type: 0
      };
      common.myFetch(apis.File_filepush, info).then(r => {
        if (r) {
          common.jump(`/creatClue?t=0&d=${r.id}`, true);
        }
      });
    },
    handleCommand(command) {
      console.log("Command received:", command);
      switch (command) {
        case "editPublish":
        case "editMaterial":
          // 关闭当前页面
          window.close()
          break;
        case "newPublish":
          this.newPublish()
          break;
        case "newMaterial":
          this.newMaterial()
          break;
        default:
          break;
      }
    },
    handleDownload() {
      if (this.idstring) {
        const info = {
          idstring: this.idstring,
          file_quality: 0
        }
        const url = apis.File_download;
        const userKeys = common.userKeys();
        const params = Object.assign({}, info, userKeys);

        common.exportRes(url, params, 1);
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if (to.query.d && to.query.d != "") {
          this.id = to.query.d;
        }
      },
    },
  },

  mounted() {
    this.id = this.$route.query.d || "";
    this.objid = this.$route.query.oid || "";
    this.objtype = this.$route.query.ot || "";
    this.t = this.$route.query.t || "";
    // 初始化音色列表
    this.getVoiceList();
    common.handleSocket(this.getSpeechResult, "speech_tts");
  },
  beforeDestroy() {
    // 组件销毁时停止播放
    this.stopVoice();
  },
};
</script>

<style lang="less" scoped>
.voiceComposeCustom {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: #e6ebf0;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 52px;
    background: #fff;
    box-shadow: 0px 1px 0px 0px #eeeeee;
    z-index: 1;

    .left {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 234px;
      flex-shrink: 0;

      .logo {
        margin-left: 67px;

        img {
          height: 28px;
          width: 99px;
        }
      }
    }

    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-left: 10px;
      margin-right: 20px;
      flex: 1;

      .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-family: PingFang-SC, PingFang-SC;
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        color: #323b4b;

        .edit-btn {
          width: 22px;
          height: 22px;
          margin-left: 10px;
          cursor: pointer;
        }

        input {
          width: 400px;
          height: 34px;
          font-size: 14px;
          background: #f1f3f3;
          border-radius: 2px;
          padding: 0 12px;
          box-sizing: border-box;

          &::placeholder {
            color: #b9c3c3;
          }
        }
      }

      .btn-container {
        display: flex;
        flex-direction: row;
        align-items: center;

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          width: 88px;
          height: 32px;
          border-radius: 4px;
          font-family: PingFang-SC, PingFang-SC;
          // font-weight: bold;
          font-size: 14px;
          border: 1px solid #41b48c;
          line-height: 20px;
        }

        .btn-compose {
          background: #41b48c;
          color: #ffffff;
        }

        .btn-save {
          background: #ffffff;
          color: #41b48c;
          margin-left: 10px;
        }
      }
    }
  }

  .content {
    display: flex;
    flex-direction: row;
    flex: 1;

    .sidebar {
      width: 234px;
      flex-shrink: 0;
      background: #fafbfc;
      padding: 20px 0 0 10px;

      .sidebar-hint {
        font-family: PingFang-SC, PingFang-SC;
        font-weight: bold;
        font-size: 16px;
        color: #323b4b;
        margin-bottom: 13px;
      }

      .voice-list {
        overflow-y: auto;
        height: calc(100vh - 100px);
        padding-right: 10px;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background: #b9c3c3;
          border-radius: 3px;
          opacity: 0.5;
        }
      }

      .voice-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 5px 14px;
        border-radius: 4px;
        cursor: pointer;
        min-height: 30px;
        margin-bottom: 6px;
        line-height: 20px;

        &:hover {
          background: rgba(185, 195, 195, 0.15);

          .voice-item-img-play {
            display: block;
          }
        }

        .voice-item-name {
          font-family: PingFang-SC, PingFang-SC;
          font-weight: bold;
          font-size: 14px;
          color: #323b4b;
        }

        .voice-item-img {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .voice-item-img img {
          width: 20px;
          height: 20px;
        }

        .voice-item-img-play,
        .voice-item-img-live {
          display: none;
        }

        &.active {
          background: #e6f1ed;
          border: 1px solid #41b48c;
        }

        .voice-item-img.isPlaying {
          .voice-item-img-live {
            display: block;
          }
          .voice-item-img-play {
            display: none;
          }
        }
      }
    }

    .main {
      padding: 10px 0 0 10px;
      flex: 1;

      &-editor {
        flex: 1;
      }

      &-editor-preview {
        height: calc(100% - 58px);
      }

      .preview-audio {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 58px;
        background: #ffffff;
        box-shadow: 4px 4px 20px 0px rgba(5, 10, 15, 0.1);
        border-radius: 4px 4px 0px 0px;
        z-index: 1;

        .left {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-left: 20px;

          span {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 500;
            font-size: 14px;
            color: #050f0f;
            line-height: 20px;
            margin-right: 10px;
            white-space: nowrap;
          }
        }

        .right {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-right: 22px;

          .btn-preview {
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            width: 88px;
            height: 32px;
            border-radius: 4px;
            font-family: PingFang-SC, PingFang-SC;
            // font-weight: bold;
            font-size: 14px;
            line-height: 20px;
            margin-left: 10px;
            text-decoration: none;
          }

          .btn-download {
            background: #41b48c;
            color: #ffffff;
          }

          .btn-insert {
            border: 1px solid #41b48c;
            color: #41b48c;
          }
        }
      }
    }
  }
}
</style>
<style>
.voice-compose-btns {
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #ffffff;
    color: #41b48c;
  }
}
</style>
